import { useHistory } from "react-router";

import type { BadgeProps } from "@alpacahq/ui/old";

import { useGetBillingOverview, useGetElitePerks } from "~/v2/api/hooks";
import type { Account } from "~/v2/api/rest/account";
import { Path } from "~/v2/path";
import { isPaperOrOnboarding } from "../../../../utils";
import { FeatureCard } from "./FeatureCard";

export const MarketDataCard = ({ account }: { account?: Account }) => {
  const history = useHistory();
  const { billing } = useGetBillingOverview({
    options: { enabled: !!account?.id },
  });
  const { perks } = useGetElitePerks({
    accountID: account?.id ?? "",
    options: {
      enabled: !!account?.id && !isPaperOrOnboarding(account),
    },
  });

  const onClick = () => history.push(Path.ROUTE_MARKET_DATA);

  const badge: { variant: BadgeProps["variant"]; text: string } =
    billing?.plan || perks?.market_data
      ? {
          variant: "blue",
          text: `Active`,
        }
      : {
          variant: "purple",
          text: "Eligible to upgrade",
        };

  const body = `Subscription Status: ${
    billing?.plan || perks?.market_data ? "Algo Trader Plus" : "Basic"
  }`;

  const button = {
    text:
      billing?.plan || perks?.market_data
        ? "Manage Subscription"
        : "Upgrade to Algo Trader Plus",
    onClick,
  };

  return (
    <FeatureCard
      title="Market Data"
      badge={badge}
      body={body}
      button={button}
    />
  );
};
